import { render, staticRenderFns } from "./resultadosBusqueda.vue?vue&type=template&id=a3aa15ac&scoped=true&"
import script from "./resultadosBusqueda.vue?vue&type=script&lang=js&"
export * from "./resultadosBusqueda.vue?vue&type=script&lang=js&"
import style0 from "./resultadosBusqueda.vue?vue&type=style&index=0&id=a3aa15ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3aa15ac",
  null
  
)

export default component.exports